import { useEffect } from "react";
import {useSelector, useDispatch} from 'react-redux'
import {statisticsRequest} from "features/Statistics/statisticsSlice"


const useStatisticsList = (_start, _limit) => {
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(statisticsRequest());    
  }, [dispatch]);

  return useSelector((state) => {
    if(state.statistics.statistics) return state.statistics.statistics;
    return [];
  });
};

export default useStatisticsList;
